import { INTERMEDIARIES } from "utils/constants";
import { createExporter } from "utils/createExporter";

export const IntermediaryExporter = createExporter(
  `administration_${INTERMEDIARIES}.xlsx`,
  [
    { key: "companyName", label: "име на фирмата" },
    { key: "personName", label: "лице за контакт" },
    { key: "phoneNumber", label: "телефон" },
    { key: "email", label: "имейл" },
  ],
  record => ({
    ...record,
  }),
);
